import React, {PropTypes}   from 'react';
import { Link }             from 'react-router';
import { FormattedMessage } from 'react-intl';

import { Header, Page, PageMain, PageLeft, Collapsible, Button }    from 'routes/app/components';
import Preloader from 'routes/app/components/Preloader';
import Visit from './Visit/Visit';
import VisitFilter from '../../containers/VisitFilter';

const VisitOverview = ({isLoading, visits, actions:{deleteVisit, getUnits, getGoods, getVisits, getDocs}}) => (
    <section>
        <Header>
            <h1><FormattedMessage id="visits.overview.pageTitle"/></h1>
        </Header>
        <Page>
            <PageMain title={<FormattedMessage id="visits.overview.mainTitle"/>} full>


                <Button waves="light" icon="cached" className="visit-refresh" onClick={()=>getVisits()} flat><FormattedMessage id="visit.refresh" /></Button>

                <VisitFilter getVisits={getVisits} />

                {isLoading ?

                    <Preloader />

                    :

                    Object.keys(visits).length ?

                        <div className="visit-overview">
                            <div className="reg-header header">
                                <div className="reg-header__status header"><FormattedMessage id="visit.status" /></div>
                                <div className="reg-header__visit header"><FormattedMessage id="visit.number" /></div>
                                <div className="reg-header__date header"><FormattedMessage id="visit.date" /></div>
                                <div className="reg-header__timeslot header"><FormattedMessage id="visit.timeslot" /></div>
                                <div className="reg-header__licenseplate header"><FormattedMessage id="visit.licenseplate" /></div>
                            </div>
                            <Collapsible accordion>

                                {visits.map(visit => (
                                    <Visit key={visit.trac} visit={visit} onDelete={deleteVisit} getUnits={getUnits} getGoods={getGoods} getDocs={getDocs}/>
                                ))}

                            </Collapsible>
                        </div>

                        :

                        <p><FormattedMessage id="visits.overview.noVisits"/></p>

                }

            </PageMain>
        </Page>
    </section>
);

VisitOverview.propTypes = {
    isLoading: PropTypes.bool,
    visits: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    actions: PropTypes.shape({
        getVisits: PropTypes.func,
        deleteVisit: PropTypes.func,
        getUnits: PropTypes.func,
        getGoods:PropTypes.func,
        getDocs:PropTypes.func
    })
};

VisitOverview.defaultProps = {
    visits: {},
    isLoading: true
};

export default VisitOverview;
